// extracted by mini-css-extract-plugin
export default {"quizCardWrapper":"styles_quizCardWrapper__LgIv-","tileIcon":"styles_tileIcon__i2YbU","cardSelectBtn":"styles_cardSelectBtn__FwMZa"};